import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/images/empty-state-add-product-modal.png'


const _hoisted_1 = {
  key: 1,
  "data-testid": "transfer-order-add-product-search-empty-state",
  class: "empty-state"
}
const _hoisted_2 = {
  key: 2,
  "data-testid": "transfer-order-add-product-empty-state",
  class: "empty-state"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty-state"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  "data-testid": "transfer-order-add-product-modal-close-btn",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.closeOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("Add a product")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_searchbar, {
              "data-testid": "transfer-order-add-product-search-input",
              onIonFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectSearchBarText($event))),
              modelValue: _ctx.queryString,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryString) = $event)),
              placeholder: _ctx.translate('Search SKU or product name'),
              onKeyup: _withKeys(_ctx.handleSearch, ["enter"]),
              onIonInput: _ctx.handleInput
            }, null, 8, ["modelValue", "placeholder", "onKeyup", "onIonInput"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      "data-testid": "transfer-order-add-product-modal-content",
      ref: "contentRef",
      "scroll-events": true,
      onIonScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enableScrolling()))
    }, {
      default: _withCtx(() => [
        (_ctx.products.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createBlock(_component_ion_list, {
                  key: product.productId,
                  "data-testid": `transfer-order-add-product-row-${product.productId}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxpShopifyImg, {
                              src: product.mainImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(product.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(product.productId)) : _ctx.getProduct(product.productId).productName), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(product.productId))), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(product.productId).productFeatures)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_ctx.isProductAvailableInOrder(product.productId))
                          ? (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 0,
                              "data-testid": `transfer-order-add-product-added-icon-${product.productId}`,
                              color: "success",
                              icon: _ctx.checkmarkCircle
                            }, null, 8, ["data-testid", "icon"]))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              "data-testid": `transfer-order-add-product-add-btn-${product.productId}`,
                              fill: "outline",
                              onClick: ($event: any) => (_ctx.addtoOrder(product))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Add to Transfer Order")), 1)
                              ]),
                              _: 2
                            }, 1032, ["data-testid", "onClick"]))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["data-testid"]))
              }), 128)),
              _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                "data-testid": "transfer-order-add-product-infinite-scroll",
                onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreProducts($event))),
                threshold: "100px",
                ref: "infiniteScrollRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    "loading-spinner": "crescent",
                    "loading-text": _ctx.translate('Loading')
                  }, null, 8, ["loading-text"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.isScrollable]
              ])
            ], 64))
          : (_ctx.queryString && _ctx.isSearching && !_ctx.products.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", null, _toDisplayString(_ctx.translate("No products found")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("p", null, _toDisplayString(_ctx.translate("Enter a SKU, or product name to search a product")), 1)
              ]))
      ]),
      _: 1
    }, 512)
  ], 64))
}